import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import AxiosApiClient from '../../components/utils/AxiosApiClient';
import AuthUtility from '../frontend/auth/AuthUtility';
import LoadingSpinner from '../frontend/LoadingSpinner';
import { LogoutService } from '../utils/LogoutService';

import swal from 'sweetalert';

import edit_icon from '../../assets/frontend/images/edit_icon.png';
import logout_icon from '../../assets/frontend/images/logout_icon.png';

function Account() {

	const navHistory = useNavigate();

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}

	// using hooks
	const [isLoading, setIsLoading] = useState(false);
	const [isMounted, setIsMounted] = useState(false);

	// Initial call for user list items
	useEffect(() => {

		if (!AuthUtility.isLoggedIn()) {
			//user not authenticated on server so remove from local storage
			AuthUtility.clearAuthData()
			navHistory('/');
		}

		if (isMounted) {
			console.log('[Account - useEffect] mounted');
		} else {
			setIsMounted(true);
		}

	}, [isMounted]);

	return (
		<div className="body-content bg-fff pt-70l-110m-60s pb-40">
		
			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-left">
						<div className="font-source-sans font-size-24 font-weight-800 bb1-555 uppercase italic pb-5">Account</div>
					</div>
				</div>
			</div>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ccc p-20l-10s">

					<div className="large-6 medium-6 small-6 cell text-left">
						<div className="font-source-sans font-size-18 font-weight-700 underline uppercase italic">Profile</div>
					</div>

					<div className="large-6 medium-6 small-6 cell text-right">
						<Link to={localStorage.getItem('auth_role') + "/profile"} className="button icon"><img src={edit_icon} alt="profile" /></Link>
					</div>

					<div className="large-12 medium-12 small-12 cell text-left pt-20l-10s">
						<table className="unstriped unbordered mb-0">
							<tbody>
								<tr><td className="font-source-sans font-size-16l-14s font-weight-400 width-100px pb-20">Name:</td><td className="font-source-sans font-size-16l-14s font-weight-600 pb-20">{localStorage.getItem('auth_first_name') + ' ' + localStorage.getItem('auth_last_name')}</td></tr>
								<tr><td className="font-source-sans font-size-16l-14s font-weight-400 width-100px pb-20">Email:</td><td className="font-source-sans font-size-16l-14s font-weight-600 pb-20">{localStorage.getItem('auth_email')}</td></tr>
								<tr><td className="font-source-sans font-size-16l-14s font-weight-400 width-100px pb-20">Role:</td><td className="font-source-sans font-size-16l-14s font-weight-600 pb-20">{localStorage.getItem('auth_role')}</td></tr>
								<tr><td className="font-source-sans font-size-16l-14s font-weight-400 width-100px pb-20">Password:</td><td className="font-source-sans font-size-16l-14s font-weight-600 pb-20">********</td></tr>
								<tr><td className="font-source-sans font-size-16l-14s font-weight-400 width-100px">Paypal Email:</td><td className="font-source-sans font-size-16l-14s font-weight-600">{localStorage.getItem('auth_paypal_email')}</td></tr>
							</tbody>
						</table>
					</div>

				</div>
			</div>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ccc p-20l-10s">

					<div className="large-6 medium-6 small-6 cell text-left">
						<div className="font-source-sans font-size-18 font-weight-700 underline uppercase italic">Logout</div>
					</div>

					<div className="large-6 medium-6 small-6 cell text-right">
						<div className="horizontal-container float-right">
							{isLoading &&
							<span className="element pr-10">
								<LoadingSpinner paddingclassName="none" sizeclassName="none" />
							</span>
							}
							<span className="element">
								<Link onClick={() => LogoutService({ setIsLoading, navHistory, swal })} className="button icon"><img src={logout_icon} alt="logout" /></Link>
							</span>
						</div>
					</div>

				</div>
			</div>

		</div>
	);
}

export default Account;